import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedI18nModule } from '@lcms/shared/i18n';
import { SwinLandingComponent } from 'apps/shell/src/app/modules/auth/components/swin-landing/swin-landing.component';
import {CommonModule} from "@angular/common";

const routes: Routes = [
  {
    path : '',
    component: SwinLandingComponent,
    children: [
      {
        path: 'signup',
        loadComponent: () =>
          import('apps/mfesignup/src/app/remote-entry/components/form-signup-swin/form-signup-swin.component').then((m) => m.FormSignupSwinComponent),
      },
      {
        path: 'login',
        loadComponent: () => import('apps/mfelogin/src/app/remote-entry/components/swiss-win-form-login/swiss-win-form-login.component').then((m) => m.SwissWinFormLoginComponent),
      },
      {
        path: 'forgot-password',
        loadChildren:()=>
          import('mfe-forgot/Module').then((m)=>m.RemoteEntryModule),
      },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: '**', redirectTo: 'login', pathMatch: 'full' },
    ]
  }
];

@NgModule({
  declarations: [SwinLandingComponent],
  imports: [RouterModule.forChild(routes),SharedI18nModule ,CommonModule ],
  exports: [RouterModule]
})
export class AuthRoutingModule {
}
